import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { reliablyHandleFormSubmit } from '../../common/formUtils';
import { setCloneSourceImage } from '../../../js/actions/cloningWorkflowActionCreators';
import SelectWithValidation from '../../common/SelectWithValidation';
import FormErrorNotification from '../../common/FormErrorNotification';
import { imageStatuses } from '../../../js/statuses';
import BackLink from '../../common/BackLink';

const validate = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.sourceImage)) {
        errors.sourceImage = 'Select an image to clone';
    }

    return errors;
};

const CloneSourceForm = React.createClass({
    propTypes: {
        image: PropTypes.object,
        images: PropTypes.array.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool.isRequired,
        submitting: PropTypes.bool.isRequired,
        onFormValid: PropTypes.func.isRequired,
        error: PropTypes.string,
        valid: PropTypes.bool.isRequired
    },
    componentWillMount: function () {
        const { image, onFormValid } = this.props;
        if (image) {
            reliablyHandleFormSubmit(() => {
                onFormValid({ sourceImage: image.id });
                browserHistory.replace('/clones/create/destination');
            });
        }
    },
    render: function () {
        const { images, handleSubmit, pristine, submitting, valid, onFormValid, error } = this.props;
        const goToNext = (data) => {
            return reliablyHandleFormSubmit(() => {
                onFormValid(data);
                browserHistory.push('/clones/create/destination');
            });
        };

        return <form onSubmit={handleSubmit(goToNext)}>
            <div className="form-container">
                <BackLink invisible />
                <h1>Create a new clone</h1>
                <FormErrorNotification error={error} />
                <div className="control-holder">
                    <Field name="sourceImage" label="Image" placeholder="Select image" autoFocus items={images} component={SelectWithValidation} />
                </div>
                {(valid && !pristine) &&
                    <button type="submit" className="button button--primary" disabled={submitting}>
                        Next
                    </button>}
            </div>
        </form>;
    }
});


const mapStateToProps = (state) => {
    return {
        images: Array.from(state.images.value.values()).filter(image =>
            image.status.state === imageStatuses.created
        ).map(image => {
            return {
                id: image.id,
                value: image.name
            };
        })
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormValid: (data) => {
            dispatch(setCloneSourceImage(data.sourceImage));
        }
    };
};

const component = connect(mapStateToProps, mapDispatchToProps)(CloneSourceForm);

export default reduxForm({
    form: 'CloneSource',
    validate
})(component);



// WEBPACK FOOTER //
// ./src/components/cloning/CloneSourcePage/cloneSourceForm.jsx